import { Fit } from "@seneca/image-service-client";

import { getDimensionFromCSSVar } from "seneca-common/utils/functions";

import { ModuleDeviceRequirements } from "features/module/types";

import styles from "../components/common.module.scss";

export const assetParameters = {
  default: {
    height: getDimensionFromCSSVar(styles["max-image-height"]),
    width: getDimensionFromCSSVar(styles["max-image-width"]),
    fit: Fit.INSIDE
  }
};

export const DEVICE_REQUIREMENTS: ModuleDeviceRequirements = {
  minModuleWidth: 300,
  desktopOnly: false
};

//there are four styles for element except for icons
//correct, incorrect, neutral and different neutral to disable onHover css style

export const buttonStylesheet = {
  multiplechoice: {
    buttonStyle: [
      "MultipleChoice__answer__box MultipleChoice__answer__box-correct",
      "MultipleChoice__answer__box MultipleChoice__answer__box-incorrect",
      "MultipleChoice__answer__box MultipleChoice__answer__box-neutral",
      "MultipleChoice__answer__box MultipleChoice__answer__box-neutral-inactive"
    ],
    textStyle: [
      "MultipleChoice__answer__text MultipleChoice__answer__text-correct",
      "MultipleChoice__answer__text MultipleChoice__answer__text-incorrect",
      "MultipleChoice__answer__text MultipleChoice__answer__text-neutral",
      "MultipleChoice__answer__text MultipleChoice__answer__text-neutral"
    ],
    iconStyle: ["fa fa-check fa-2x", "fa fa-times fa-2x", ""]
  },
  equation: {
    buttonStyle: [
      "MultipleChoice__equation__answer__box MultipleChoice__equation__answer__box-correct",
      "MultipleChoice__equation__answer__box MultipleChoice__equation__answer__box-incorrect",
      "MultipleChoice__equation__answer__box MultipleChoice__equation__answer__box-neutral",
      "MultipleChoice__equation__answer__box MultipleChoice__equation__answer__box-neutral-inactive"
    ],
    textStyle: [
      "MultipleChoice__equation__answer__text MultipleChoice__equation__answer__text-correct",
      "MultipleChoice__equation__answer__text MultipleChoice__equation__answer__text-incorrect",
      "MultipleChoice__equation__answer__text MultipleChoice__equation__answer__text-neutral",
      "MultipleChoice__equation__answer__text MultipleChoice__equation__answer__text-neutral"
    ],
    //empty icon style will disable rendering
    iconStyle: ["", "", ""]
  }
};
